/* IM Cart – drawer + réduction + affichage 3POUR2 + variantes propres */
(() => {
  'use strict';

  const $ = (q, c = document) => c.querySelector(q);
  const root = $('#im-cart');
  if (!root) return;

  /* ---------- Raccourcis éléments ---------- */
  const els = {
    items: $('[data-imc-items]', root),
    empty: $('[data-imc-empty]', root),

    // Livraison offerte
    shipWrap: $('[data-imc-shipprog]', root),
    shipMsg: $('[data-imc-ship-msg]', root),
    shipCount: $('[data-imc-ship-count]', root),
    shipBar: $('[data-imc-ship-bar]', root),

    // Discount UI
    discTog: $('[data-imc-disc-tog]', root),
    discPanel: $('#imc-disc-panel', root),
    discInput: $('[data-imc-disc-input]', root),
    discApply: $('[data-imc-disc-apply]', root),
    discHint: $('[data-imc-disc-hint]', root),
    discLine: $('[data-imc-disc-line]', root),
    discCode: $('[data-imc-disc-code]', root),
    discClear: $('[data-imc-disc-clear]', root),

    // Récap
    shippingRow: $('[data-imc-shipping-row]', root),
    shippingValue: $('[data-imc-shipping]', root),
    beforeRow: $('[data-imc-before-row]', root),
    before: $('[data-imc-before]', root),
    discountRow: $('[data-imc-discount-row]', root),
    discAmount: $('[data-imc-disc-amount]', root),

    // Totaux + checkout
    total: $('[data-imc-total]', root),
    totalLoader: $('[data-imc-total-loader]', root),
    count: $('[data-imc-count]', root),
    checkout: $('[data-imc-checkout]', root),

    // Note panier
    noteInput: $('[data-imc-note-input]', root),
    noteStatus: $('[data-imc-note-status]', root),
  };

  const HEADER_COUNT_SELECTORS = [
    '#im-cart-count',
    '.js-cart-count',
    '.site-header__cart-indicator',
    '.header-cart-count',
    '[data-cart-count]'
  ].join(',');

  const toSafeCount = (raw) => {
    const n = Number(raw);
    if (!Number.isFinite(n) || n <= 0) return 0;
    return Math.floor(n);
  };

  function syncHeaderCounts(rawCount) {
    const count = toSafeCount(rawCount);
    checkVarMoment(count);
    const nodes = document.querySelectorAll(HEADER_COUNT_SELECTORS);
    if (!nodes.length) return;
    nodes.forEach((el) => {
      el.textContent = String(count);
      el.setAttribute('data-count', String(count));
    });
  }

  /* ---------- « Décision VAR » : célébration sobre au franchissement d'un palier cadeau ---------- */
  let imcLastCount = null; // null = pas encore initialisé (on ne célèbre jamais l'état initial)
  function checkVarMoment(count) {
    if (imcLastCount === null) { imcLastCount = count; return; }
    /* Priorité au palier le plus haut : un saut direct 2→6 (saisie clavier)
       célèbre le 6ᵉ offert (le plus gros avantage), pas seulement le 3ᵉ. */
    if (imcLastCount < 6 && count >= 6) varMoment(6);
    else if (imcLastCount < 3 && count >= 3) varMoment(3);
    imcLastCount = count;
  }
  function varMoment(kind) {
    try {
      if (sessionStorage.getItem('imc_var_' + kind)) return; // une seule fois par session et par palier
      sessionStorage.setItem('imc_var_' + kind, '1');
    } catch (e) { /* stockage bloqué : on célèbre quand même, au pire 2× */ }
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const d = document.createElement('div');
    d.className = 'imc-var';
    d.setAttribute('role', 'status'); // annoncé par les lecteurs d'écran à l'insertion
    d.innerHTML =
      '<div class="imc-var__card"><span class="imc-var__k">Décision VAR</span>' +
      '<span class="imc-var__v">' + (kind === 3 ? '3ᵉ maillot offert' : '6ᵉ maillot offert') +
      ' — accordé <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 13 5 5L19 7"/></svg></span></div>';
    document.body.appendChild(d);
    requestAnimationFrame(() => d.classList.add('is-on'));
    setTimeout(() => { d.classList.remove('is-on'); setTimeout(() => d.remove(), 400); }, 1500);
    try { navigator.vibrate && navigator.vibrate(35); } catch (e) { /* no-op */ }
  }

  let headerRefreshTimer = null;
  let headerRefreshInFlight = false;
  function queueHeaderCountRefresh(delay = 80) {
    if (headerRefreshTimer) clearTimeout(headerRefreshTimer);
    headerRefreshTimer = setTimeout(async () => {
      if (headerRefreshInFlight) return;
      headerRefreshInFlight = true;
      try {
        const c = await getCart();
        syncHeaderCounts(c?.item_count || 0);
      } catch (e) {
        /* no-op */
      } finally {
        headerRefreshInFlight = false;
      }
    }, delay);
  }

  function installHeaderCountAutoRefresh() {
    if (!window.__imcHeaderCountPatchFetch && typeof window.fetch === 'function') {
      const nativeFetch = window.fetch.bind(window);
      window.fetch = function patchedFetch(resource, init) {
        const url = (typeof resource === 'string' ? resource : resource?.url) || '';
        const watch = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(url);
        return nativeFetch(resource, init).then(
          (res) => {
            // Skip si c'est NOTRE opération interne (render() met déjà le compteur à jour)
            if (watch && !_suppressHeaderRefresh) queueHeaderCountRefresh(60);
            return res;
          },
          (err) => {
            if (watch && !_suppressHeaderRefresh) queueHeaderCountRefresh(120);
            throw err;
          }
        );
      };
      window.__imcHeaderCountPatchFetch = true;
    }

    if (!window.__imcHeaderCountPatchXhr && window.XMLHttpRequest) {
      const xhrOpen = window.XMLHttpRequest.prototype.open;
      const xhrSend = window.XMLHttpRequest.prototype.send;

      window.XMLHttpRequest.prototype.open = function patchedOpen(method, url) {
        this.__imcWatchCart = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(String(url || ''));
        return xhrOpen.apply(this, arguments);
      };

      window.XMLHttpRequest.prototype.send = function patchedSend() {
        if (this.__imcWatchCart) {
          this.addEventListener('loadend', () => queueHeaderCountRefresh(70), { once: true });
        }
        return xhrSend.apply(this, arguments);
      };
      window.__imcHeaderCountPatchXhr = true;
    }
  }

  /* === AJOUT : helper shimmer sur le total === */
  const setTotalLoading = (on) => {
    if (!els.total) return;
    els.total.classList.toggle('imc-total--loading', !!on);
    els.total.setAttribute('aria-busy', on ? 'true' : 'false');
    if (els.totalLoader) els.totalLoader.hidden = !on;
  };

  /* ---------- Helpers ---------- */
  const cur = (window.Shopify?.currency?.active) || 'EUR';
  const money = (cents) => {
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); }
    catch { return (cents / 100).toFixed(2) + ' €'; }
  };

  const labelMap = new Map([
    // normalisations -> étiquettes voulues
    ['s', 'Taille'],
    ['taille', 'Taille'],
    ['nom', 'Nom'],
    ['numero', 'Numéro'],
    ['numéro', 'Numéro'],
    ['name_below', 'Nom en dessous'],
    ['nom_en_dessous', 'Nom en dessous'],
    ['nom_sous_le_numero', 'Nom en dessous'],
    ['nom sous le numéro', 'Nom en dessous'],
    ['sous le numéro', 'Nom en dessous'],
    ['sous le numero', 'Nom en dessous'],
  ]);

  const norm = (k) => String(k || '').trim().toLowerCase();

  // Estimations de remise DÉSACTIVÉES (aucun code réel configuré côté Shopify).
  // Le code saisi est tout de même transmis au checkout, où la vraie remise s'applique.
  const parsePct = (code) => 0;
  const safeLocalRemove = (key) => {
    try { window.localStorage.removeItem(key); } catch (_) {}
  };
  const safeSessionGet = (key) => {
    try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
  };
  const safeSessionSet = (key, value) => {
    try { window.sessionStorage.setItem(key, value); } catch (_) {}
  };
  const safeSessionRemove = (key) => {
    try { window.sessionStorage.removeItem(key); } catch (_) {}
  };

  let cart = { items: [], items_subtotal_price: 0, item_count: 0 };
  // Quand true, le patch fetch global ne déclenche PAS de refresh header redondant
  // (utilisé pendant nos propres opérations qui rafraîchissent déjà le compteur)
  let _suppressHeaderRefresh = false;
  let noteSaveTimer = null;
  let lastSavedNote = '';
  const FREE_SHIP_THRESHOLD = 2;
  let lastShippingStep = -1;
  let shippingAnimTimer = null;
  let shipBurstTimer = null;

  /* IM FIX:
     - Aucun code promo ne doit être mémorisé entre sessions/page reload.
     - Le code promo manuel reste uniquement en mémoire de la page courante.
  */
  let discountCode = '';

  // Montants calculés côté affichage
  let estimatedPercentDiscount = 0;   // pour codes % (ex. EMMA20)
  let promo3x2Discount = 0;           // pour 3POUR2 simulation (affichage)
  let freeUnitsMap = {};              // { line_key: nb d’unités offertes } pour l'affichage ligne

  /* ---------- API Shopify ---------- */
  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  /* ============================================================
     REGROUPEMENT des lignes scindées par la remise automatique.
     La Shopify Function « Paliers » scinde une même variante en plusieurs
     lignes aux CLÉS DIFFÉRENTES (plein tarif / −35% / offert). Pour le client
     c'est UNE ligne. Sans regroupement, changer la quantité « par clé » ne
     touche qu'une des lignes et le total dérive (bug prouvé : 6 voulu → 9).
     ============================================================ */
  let _lineGroupByKey = new Map(); // clé affichée (1re du groupe) -> [toutes les clés du groupe]

  function groupCartItems(items) {
    const byId = new Map(); // variant|props -> item fusionné
    const out = [];
    _lineGroupByKey = new Map();
    (items || []).forEach((it) => {
      const gid = `${it.variant_id}|${JSON.stringify(it.properties || {})}`;
      if (!byId.has(gid)) {
        const merged = Object.assign({}, it);
        // La Function isole l'unité offerte sur sa propre ligne scindée (final 0) :
        // on mémorise si le groupe contient une VRAIE unité gratuite, pour ne jamais
        // étiqueter « Offert » une ligne seulement remisée (−35%).
        merged.hasZeroUnit = (it.final_line_price === 0 && (it.original_line_price || 0) > 0);
        byId.set(gid, merged);
        out.push(merged);
        _lineGroupByKey.set(merged.key, [it.key]);
      } else {
        const m = byId.get(gid);
        m.quantity = (m.quantity || 0) + (it.quantity || 0);
        m.line_price = (m.line_price || 0) + (it.line_price || 0);
        m.final_line_price = (m.final_line_price || 0) + (it.final_line_price || 0);
        m.original_line_price = (m.original_line_price || 0) + (it.original_line_price || 0);
        m.hasZeroUnit = m.hasZeroUnit || (it.final_line_price === 0 && (it.original_line_price || 0) > 0);
        _lineGroupByKey.get(m.key).push(it.key);
      }
    });
    return out;
  }

  /* ============================================================
     Gestion quantité OPTIMISÉE — accumulation + debounce + single-fetch
     - Clics +/- rapides accumulés → 1 seule requête vers la qty finale
     - Réponse de /cart/change.js réutilisée (pas de refetch /cart.js)
     - Optimistic UI immédiat, anti-flash, gestion d'erreur (resync)
     ============================================================ */
  const _qtyTarget = new Map();   // key -> quantité cible souhaitée
  const _qtyTimer = new Map();    // key -> timer de debounce
  const _qtyInFlight = new Map(); // key -> cible envoyée (requête en cours)
  const QTY_DEBOUNCE_MS = 240;

  function changeQty(key, qty) {
    if (key == null) return;
    qty = Math.max(0, qty | 0);
    _qtyTarget.set(key, qty);

    // Optimistic UI immédiat (ressenti instantané)
    const itemEl = root.querySelector(`.imc-it[data-key="${key}"]`);
    if (itemEl) {
      if (qty <= 0) {
        itemEl.classList.add('removing');
        itemEl.querySelectorAll('button, input').forEach(n => { n.disabled = true; });
      } else {
        const input = itemEl.querySelector('.imc-qty__input');
        if (input) input.value = qty;
      }
    }
    setTotalLoading(true);

    // Debounce : on attend que les clics rapides se calment avant d'envoyer
    if (_qtyTimer.has(key)) clearTimeout(_qtyTimer.get(key));
    _qtyTimer.set(key, setTimeout(() => flushQty(key), QTY_DEBOUNCE_MS));
  }

  async function flushQty(key) {
    _qtyTimer.delete(key);
    // Si une requête tourne déjà pour cette ligne, on laisse le finally re-flush
    if (_qtyInFlight.has(key)) return;
    if (!_qtyTarget.has(key)) return;

    const target = _qtyTarget.get(key);
    _qtyTarget.delete(key);
    _qtyInFlight.set(key, target);

    let updatedCart = null;
    let serverOk = true;
    _suppressHeaderRefresh = true; // évite le getCart redondant du patch global
    try {
      // Mise à jour ATOMIQUE de tout le groupe (lignes scindées par la remise) :
      // la 1re clé reçoit la quantité cible, les clés sœurs passent à 0 — le serveur
      // ré-alloue ensuite offert/−35% proprement. /cart/update.js renvoie le panier.
      const members = _lineGroupByKey.get(key) || [key];
      const updates = {};
      members.forEach((k, i) => { updates[k] = (i === 0 ? target : 0); });
      const resp = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates })
      });
      serverOk = resp.ok;
      if (serverOk) {
        try { updatedCart = await resp.json(); } catch (_) { updatedCart = null; }
      }
    } catch (e) {
      serverOk = false;
      console.warn('[IMCart] changeQty error', e);
    } finally {
      _suppressHeaderRefresh = false;
    }

    // Laisse l'animation de sortie se terminer avant le re-render (anti-flash)
    if (target <= 0 && serverOk) {
      await new Promise(r => setTimeout(r, 230));
    }

    // render() avec le cart déjà renvoyé par change.js → AUCUN fetch supplémentaire
    try {
      await render(updatedCart);
    } catch (e) {
      console.warn('[IMCart] render after changeQty error', e);
    }

    _qtyInFlight.delete(key);
    setTotalLoading(false);

    // Si l'utilisateur a re-cliqué pendant la requête, on traite la nouvelle cible
    if (_qtyTarget.has(key)) flushQty(key);
  }

  /* ---------- Discount cookie Shopify : nettoyage fiable ---------- */
  const hasShopifyDiscountApplied = (c) => {
    if (!c) return false;
    if ((c.total_discount || 0) > 0) return true;
    const apps = Array.isArray(c.cart_level_discount_applications) ? c.cart_level_discount_applications : [];
    if (apps.length) return true;
    const codes = Array.isArray(c.discount_codes) ? c.discount_codes : [];
    if (codes.some(x => x && x.applicable)) return true;
    return false;
  };

  // Clear discount cookie en BACKGROUND (sans redirection)
  async function clearShopifyDiscountInBackground() {
    try {
      // Shopify enlève le code si on passe discount vide au checkout
      await fetch('/checkout?discount=', { credentials: 'same-origin' }).catch(() => {});
    } catch(e) {}
  }

  // DÉSACTIVÉ (2026-07-16) : cette routine purgait toute remise « inattendue ». Or
  // (1) la remise automatique « Paliers Grinta » est légitime et déclenchait la purge
  //     à chaque session dès 3 maillots ;
  // (2) un client arrivant via un lien code promo (influenceur) perdait son code en silence.
  // On ne retire plus JAMAIS une remise sans action explicite du client (bouton ✕ du code).
  async function ensureNoUnexpectedShopifyDiscount(c) {
    return c;
  }

  function clearDiscountPersistence() {
    safeLocalRemove('imc_discount_code');
    safeLocalRemove('imc_discount_enabled');
    safeSessionRemove('imc_discount_primed');
  }

  /* ---------- Rendu des propriétés (variante + custom fields) ---------- */
  // Échappe le HTML pour éviter toute injection (XSS) depuis les champs libres
  // (ex: nom/numéro de flocage saisis par le client).
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function renderPropsLine(it) {
    const parts = [];

    // Variante (ex: "S")
    const vt = (it.variant_title || '').trim();
    if (vt) parts.push(`<div class="imc-it__variant">${escapeHtml(vt)}</div>`);

    // Propriétés custom (le flocage Nom/Numéro/Sous le numéro est rendu en DOSSARD visuel, pas en texte)
    const p = it.properties || {};
    const kitKeys = new Set(['nom', 'numero', 'numéro', 'sous le numero', 'sous le numéro']);
    Object.keys(p).forEach((k) => {
      const v = p[k];
      if (v == null || v === '' || v === false) return;
      const keyN = norm(k);
      if (kitKeys.has(keyN) && hasKit(it)) return;
      const label = labelMap.get(keyN) || (k.charAt(0).toUpperCase() + k.slice(1));
      parts.push(`<div class="imc-it__props"><span class="k">${escapeHtml(label)}:</span> <span class="v">${escapeHtml(v)}</span></div>`);
    });

    return parts.join('');
  }

  /* ---------- Le Dossard : le flocage du client rendu comme un vrai dos de maillot ---------- */
  function kitProps(it) {
    const p = it.properties || {};
    let nom = '', num = '', sub = '';
    Object.keys(p).forEach((k) => {
      const keyN = norm(k);
      const v = String(p[k] == null ? '' : p[k]).trim();
      if (!v) return;
      if (keyN === 'nom') nom = v;
      else if (keyN === 'numero' || keyN === 'numéro') num = v;
      else if (keyN === 'sous le numero' || keyN === 'sous le numéro') sub = v;
    });
    return { nom, num, sub };
  }
  function hasKit(it) {
    const k = kitProps(it);
    return !!(k.nom || k.num);
  }
  function kitNode(it) {
    // fiche flocage COMPACTE : 3 mini-colonnes (label au-dessus, valeur dessous) —
    // étiqueté = zéro ambiguïté, 2 lignes de haut = zéro encombrement,
    // typographie neutre du site = aucune simulation du rendu réel
    const k = kitProps(it);
    if (!k.nom && !k.num) return null;
    const d = document.createElement('div');
    d.className = 'imc-kit4';
    d.setAttribute('aria-label', 'Flocage : ' + [k.nom, k.num, k.sub].filter(Boolean).join(' '));
    const cell = (lab, val) => {
      const c = document.createElement('span'); c.className = 'imc-kit4__c';
      const l = document.createElement('span'); l.className = 'l'; l.textContent = lab;
      const v = document.createElement('span'); v.className = 'v'; v.textContent = val;
      c.appendChild(l); c.appendChild(v); return c;
    };
    if (k.nom) d.appendChild(cell('Nom', k.nom.toUpperCase()));
    if (k.num) d.appendChild(cell('N°', k.num));
    if (k.sub) d.appendChild(cell('Sous le n°', k.sub.toUpperCase()));
    return d;
  }

  /* ---------- Simulation 3POUR2 (affichage uniquement) ---------- */
  function compute3for2(items) {
    // Reset
    promo3x2Discount = 0;
    freeUnitsMap = {};

    // Simulation 3POUR2 DÉSACTIVÉE : aucun code réel configuré côté Shopify.
    // (On ne montre jamais un prix réduit qui ne serait pas réellement appliqué au paiement.)
    return;

    // Liste des unités éligibles (une entrée par unité)
    const units = [];
    items.forEach(it => {
      const unitPrice = (it.price ?? it.final_price ?? 0);
      const q = it.quantity || 0;
      for (let i = 0; i < q; i++) {
        units.push({ key: it.key, unitPrice });
      }
    });

    if (!units.length) return;

    // Tri par prix croissant
    units.sort((a, b) => a.unitPrice - b.unitPrice);

    const numberFree = Math.floor(units.length / 3);
    if (numberFree <= 0) return;

    // Les "numberFree" moins chers deviennent gratuits (affichage)
    for (let i = 0; i < numberFree; i++) {
      const u = units[i];
      promo3x2Discount += u.unitPrice;
      freeUnitsMap[u.key] = (freeUnitsMap[u.key] || 0) + 1;
    }
  }

  /* ---------- DOM helpers ---------- */
  function show(el, yes) {
    if (!el) return;
    if (yes) {
      el.removeAttribute('hidden');
      el.classList.add('imc-fade--in');
      setTimeout(() => el.classList.remove('imc-fade--in'), 180);
    } else {
      el.setAttribute('hidden', 'hidden');
    }
  }

  /* ---------- Noeud article ---------- */
  function itemNode(it) {
    const t = $('#imc-item', root).content.cloneNode(true);
    const el = t.querySelector('.imc-it');
    el.dataset.key = it.key;

    // Image + titre
    const img = t.querySelector('.imc-it__img');
    img.src = it.image || it?.featured_image?.url || '';
    img.alt = it.product_title || '';

    // Variante + propriétés en colonnes
    t.querySelector('[data-imc-props]').innerHTML = renderPropsLine(it);
    const kit = kitNode(it);
    if (kit) t.querySelector('[data-imc-props]').appendChild(kit);

    // PRIX RÉEL SHOPIFY : line_price
    const lineFinal = (typeof it.line_price === 'number')
      ? it.line_price
      : 0;

    const lineOriginal = (typeof it.original_line_price === 'number')
      ? it.original_line_price
      : lineFinal;

    // Badge "Offert" UNIQUEMENT si la ligne contient une unité réellement gratuite
    // (ligne à 0 ou groupe avec une unité scindée à 0 par la Function).
    // Une ligne seulement remisée (−35% sur le 4ᵉ) reçoit un chip honnête « −35% » :
    // jamais « Offert » sur un maillot que le client paie.
    const hasSimGift = !!freeUnitsMap[it.key];
    const hasRealGift = (lineFinal === 0) || it.hasZeroUnit === true;
    const hasPartialDisc = !hasSimGift && !hasRealGift &&
      (typeof it.final_line_price === 'number' && typeof it.original_line_price === 'number' &&
       it.original_line_price > 0 && it.final_line_price < it.original_line_price);
    const discPct = hasPartialDisc
      ? Math.round((1 - it.final_line_price / it.original_line_price) * 100)
      : 0;

    t.querySelector('.imc-it__title').innerHTML =
      `${it.product_title || ''} ` +
      ((hasSimGift || hasRealGift)
        ? `<span class="imc-gift-chip">Offert</span>`
        : (discPct > 0 ? `<span class="imc-gift-chip">−${discPct}%</span>` : ''));

    // Prix affiché (ligne)
    const is3pour2 = /^3POUR2/i.test(discountCode);

    if (is3pour2) {
      const pricePerUnit = (it.price ?? it.final_price ?? 0);
      const q = it.quantity || 0;
      const nbFree = freeUnitsMap[it.key] || 0;
      const displayLinePrice = Math.max(0, (q * pricePerUnit) - (nbFree * pricePerUnit));
      t.querySelector('.imc-it__price').textContent = money(displayLinePrice);
    } else {
      if (lineOriginal > lineFinal) {
        t.querySelector('.imc-it__price').innerHTML =
          `${money(lineFinal)} <span style="text-decoration:line-through;opacity:.55;margin-left:6px;">${money(lineOriginal)}</span>`;
      } else {
        t.querySelector('.imc-it__price').textContent = money(lineFinal);
      }
    }

    // Contrôles quantité
    const q = it.quantity || 0;
    const input = t.querySelector('.imc-qty__input');
    // L'input reflète la vérité la plus récente : cible en attente > cible en vol > serveur.
    // (Sinon un render pendant une requête réafficherait la valeur serveur périmée.)
    input.value = _qtyTarget.has(it.key) ? _qtyTarget.get(it.key)
                : _qtyInFlight.has(it.key) ? _qtyInFlight.get(it.key)
                : q;
    // Base de calcul des clics = même chaîne — jamais le q figé du render, sinon des
    // clics rapides se perdent (cible réécrite à q+1) ou reculent après un re-render.
    const stepQty = (delta) => {
      const cur = _qtyTarget.has(it.key) ? _qtyTarget.get(it.key)
                : _qtyInFlight.has(it.key) ? _qtyInFlight.get(it.key)
                : (parseInt(input.value, 10) || q);
      changeQty(it.key, Math.max(0, cur + delta));
    };
    t.querySelector('.imc-qty--inc').addEventListener('click', () => stepQty(1));
    t.querySelector('.imc-qty--dec').addEventListener('click', () => stepQty(-1));
    t.querySelector('.imc-remove').addEventListener('click', () => changeQty(it.key, 0));
    input.addEventListener('change', (e) => {
      const n = parseInt(e.target.value, 10);
      // Saisie vide / non numérique / < 1 → on NE supprime PAS l'article par accident :
      // on restaure la quantité affichée. (Pour retirer : bouton « Retirer » ou « − ».)
      if (!Number.isFinite(n) || n < 1) { e.target.value = it.quantity; return; }
      changeQty(it.key, n);
    });

    return t;
  }

  /* ---------- Application visuelle des remises ---------- */
  function applyDiscountPreview() {
    estimatedPercentDiscount = 0;

    // Sans code → on masque les lignes récap "Avant / Réduction"
    if (!discountCode) {
      show(els.discLine, false);
      show(els.beforeRow, false);
      show(els.discountRow, false);
      if (els.discHint) els.discHint.hidden = true;
      updateCheckoutLink();
      return;
    }

    // Plus aucune estimation de remise affichée : on n'annonce jamais un prix réduit non garanti.
    // Le code est transmis au paiement, où la remise réelle (si le code existe) s'applique.
    estimatedPercentDiscount = 0;
    if (els.discHint) {
      els.discHint.textContent = `Code enregistré — la remise s’applique au paiement.`;
      els.discHint.hidden = false;
    }

    if (els.discCode) els.discCode.textContent = discountCode;

    // Lignes récap visibles
    if (els.before) els.before.textContent = money(cart.items_subtotal_price);
    show(els.beforeRow, true);
    show(els.discountRow, true);
    show(els.discLine, true);

    updateCheckoutLink();
  }

  /* compteur animé (montants en centimes) — dégradation propre : saute à la valeur finale si reduced-motion.
     Filet : la valeur finale est TOUJOURS posée à dur+80ms, même si les rAF sont gelés (onglet en arrière-plan). */
  function animateAmount(el, from, to, dur, fmt) {
    // jeton anti-réentrance : une nouvelle animation sur le même élément annule
    // l'ancienne (boucle + filet), sinon deux compteurs s'écrivent dessus
    const tok = (el._imcAnimTok = (el._imcAnimTok || 0) + 1);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { el.textContent = fmt(to); return; }
    const t0 = performance.now();
    (function step(now) {
      if (el._imcAnimTok !== tok) return;
      const p = Math.min(1, (now - t0) / dur);
      const e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(from + (to - from) * e));
      if (p < 1) requestAnimationFrame(step);
    })(t0);
    setTimeout(function () { if (el._imcAnimTok === tok) el.textContent = fmt(to); }, dur + 80);
  }

  function updateTotals() {
    // Toujours le total RÉEL Shopify (plus aucune simulation de remise locale).
    const total = (typeof cart.total_price === 'number')
      ? cart.total_price
      : (cart.items_subtotal_price ?? 0);

    if (els.discAmount) {
      // Remise réellement appliquée par Shopify. Les remises de la Function (3ᵉ offert…)
      // ne remplissent pas toujours total_discount → on prend aussi la différence
      // prix original − prix final, qui reflète TOUTES les remises réelles.
      const discField = (typeof cart.total_discount === 'number') ? cart.total_discount : 0;
      const discDelta = Math.max(0, (cart.original_total_price || 0) - (cart.total_price || 0));
      const realDisc = Math.max(discField, discDelta);
      const prevDisc = parseInt(els.discAmount.dataset.imcVal || '0', 10);
      if (realDisc > 0 && realDisc !== prevDisc) {
        // le cadeau TOMBE sous les yeux : compte de l'ancienne valeur vers la nouvelle en 0,6 s
        els.discAmount.dataset.imcVal = String(realDisc);
        els.discAmount.classList.add('imc-disc--live');
        animateAmount(els.discAmount, prevDisc, realDisc, 600, (v) => `− ${money(v)}`);
      } else if (realDisc <= 0) {
        els.discAmount.dataset.imcVal = '0';
        els.discAmount.classList.remove('imc-disc--live');
        els.discAmount.textContent = '—';
      }
      // La ligne « Réductions » doit être VISIBLE dès qu'une remise réelle s'applique
      // (les remises de la Function arrivent sans code promo ; applyDiscountPreview,
      // exécutée avant, ne gère que le cas code saisi).
      if (realDisc > 0) show(els.discountRow, true);
      else if (!discountCode) show(els.discountRow, false);
    }

    if (els.total) {
      els.total.textContent = money(total);
      els.total.closest('.imc-row')?.classList.add('imc-fade--in');
      setTimeout(() => els.total.closest('.imc-row')?.classList.remove('imc-fade--in'), 180);
    }

    return total;
  }

  function updateCheckoutButtonLabel(totalCents) {
    if (!els.checkout) return;
    const safeTotal = Number.isFinite(Number(totalCents)) ? Number(totalCents) : 0;
    els.checkout.textContent = `Payer maintenant • ${money(Math.max(0, safeTotal))}`;
  }


  /* ---------- Checkout + Remise persistante ---------- */
  let imcIsNavigating = false;
  function updateCheckoutLink() {
    const enc = discountCode ? encodeURIComponent(discountCode) : '';
    const url = discountCode ? `/discount/${enc}?redirect=/checkout` : `/checkout`;
    if (!els.checkout) return;
    els.checkout.setAttribute('href', url);

    // PRÉLOAD de /checkout au survol (souris) ou contact (mobile)
    // Quand l'utilisateur s'apprête à cliquer, on commence déjà à charger la page
    if (!els.checkout.dataset.imPreloadBound) {
      els.checkout.dataset.imPreloadBound = '1';
      const preload = () => {
        const currentUrl = els.checkout.getAttribute('href') || url;
        if (els.checkout.dataset.imPreloadedUrl === currentUrl) return;
        els.checkout.dataset.imPreloadedUrl = currentUrl;
        // Supprime l'ancien prefetch s'il existe
        const old = document.querySelector('link[data-im-checkout-prefetch]');
        if (old) old.remove();
        // Ajoute un nouveau prefetch
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.as = 'document';
        link.href = currentUrl;
        link.setAttribute('data-im-checkout-prefetch', '');
        document.head.appendChild(link);
      };
      els.checkout.addEventListener('pointerenter', preload, { passive: true });
      els.checkout.addEventListener('touchstart', preload, { passive: true });
      els.checkout.addEventListener('focus', preload, { passive: true });
    }

    els.checkout.onclick = (e) => {
      e.preventDefault();

      // Si une nav est déjà en cours mais que l'utilisateur reclique (impatience),
      // on FORCE la navigation à nouveau (peut-être que la 1ère a échoué silencieusement)
      if (imcIsNavigating) {
        /* log retiré (prod) */
        try { window.location.href = url; } catch (_) {
          try { window.location.assign(url); } catch (_) {}
        }
        return;
      }

      imcIsNavigating = true;
      /* log retiré (prod) */

      // Loading state : spinner + "Chargement..."
      const originalHtml = els.checkout.innerHTML;
      els.checkout.classList.add('im-loading');
      els.checkout.innerHTML = '<span class="im-loading-spinner" aria-hidden="true"></span><span>Chargement...</span>';

      // Reset rapide (2.5s) : si la nav fonctionne, la page change avant.
      // Si elle échoue, l'utilisateur peut re-cliquer rapidement au lieu d'attendre 8s.
      setTimeout(() => {
        imcIsNavigating = false;
        els.checkout.classList.remove('im-loading');
        els.checkout.innerHTML = originalHtml;
      }, 2500);

      // Lance la navigation
      try {
        window.location.assign(url);
      } catch (err) {
        console.error('[IM checkout] location.assign a échoué:', err);
        // Fallback : forcer via href
        try { window.location.href = url; } catch (_) {}
      }
    };
  }

  /* Reset le state checkout au retour de la page (back button) */
  window.addEventListener('pageshow', () => {
    imcIsNavigating = false;
    if (els.checkout && els.checkout.classList.contains('im-loading')) {
      els.checkout.classList.remove('im-loading');
      updateCheckoutLink();
    }
  });

  /* Si la nav démarre vraiment (beforeunload fired), on est sûr que ça marche */
  window.addEventListener('beforeunload', () => {
    // La nav démarre — on peut clear le timeout (Page va changer de toute façon)
    // Pas de cleanup nécessaire ici, juste un marqueur visuel pour le user qui voit "Chargement..."
  });

  function primeDiscountCookie() {
    if (!discountCode) return;

    if (safeSessionGet('imc_discount_primed') === discountCode) return;
    safeSessionSet('imc_discount_primed', discountCode);

    fetch(`/discount/${encodeURIComponent(discountCode)}?redirect=/`, { credentials: 'same-origin' })
      .catch(() => {});
  }

  async function saveCartNote(force = false) {
    if (!els.noteInput) return;
    const note = els.noteInput.value || '';
    if (!force && note === lastSavedNote) return;

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note })
      });
      lastSavedNote = note;
      if (els.noteStatus) {
        els.noteStatus.textContent = 'Enregistré';
        els.noteStatus.hidden = false;
        setTimeout(() => {
          if (els.noteStatus) els.noteStatus.hidden = true;
        }, 1200);
      }
    } catch (e) {
      if (els.noteStatus) {
        els.noteStatus.textContent = 'Erreur';
        els.noteStatus.hidden = false;
      }
    }
  }

  function queueCartNoteSave() {
    if (!els.noteInput) return;
    if (noteSaveTimer) clearTimeout(noteSaveTimer);
    noteSaveTimer = setTimeout(() => {
      saveCartNote(false);
    }, 450);
  }

  function playShippingStepAnimation(step) {
    if (!els.shipWrap) return;
    const midClass = 'imc-shipprog--pulse-mid';
    const finalClass = 'imc-shipprog--celebrate';
    const targetClass = step === 2 ? finalClass : midClass;
    const duration = step === 2 ? 1050 : 900;

    els.shipWrap.classList.remove(midClass, finalClass);
    void els.shipWrap.offsetWidth;
    els.shipWrap.classList.add(targetClass);

    if (shippingAnimTimer) clearTimeout(shippingAnimTimer);
    shippingAnimTimer = setTimeout(() => {
      els.shipWrap.classList.remove(midClass, finalClass);
    }, duration);

    if (step === 2) {
      playShippingEmojiBurst();
    }
  }

  function playShippingEmojiBurst() {
    if (!els.shipWrap) return;

    const oldLayer = els.shipWrap.querySelector('.imc-shipprog__burst');
    if (oldLayer) oldLayer.remove();

    const layer = document.createElement('div');
    layer.className = 'imc-shipprog__burst';

    const icons = ['🎁', '⚽', '✨', '🚚', '✨', '⚽'];
    const dropsCount = 10;

    for (let i = 0; i < dropsCount; i += 1) {
      const drop = document.createElement('span');
      const icon = icons[Math.floor(Math.random() * icons.length)];
      const x = 8 + Math.random() * 84;
      const delay = Math.round(Math.random() * 380);
      const dur = 1400 + Math.round(Math.random() * 500);
      const drift = -18 + Math.round(Math.random() * 36);
      const rot = -35 + Math.round(Math.random() * 70);
      const size = 12 + Math.round(Math.random() * 6);

      drop.className = 'imc-shipprog__drop';
      drop.textContent = icon;
      drop.style.setProperty('--x', `${x}%`);
      drop.style.setProperty('--delay', `${delay}ms`);
      drop.style.setProperty('--dur', `${dur}ms`);
      drop.style.setProperty('--drift', `${drift}px`);
      drop.style.setProperty('--rot', `${rot}deg`);
      drop.style.setProperty('--size', `${size}px`);
      layer.appendChild(drop);
    }

    els.shipWrap.appendChild(layer);
    if (shipBurstTimer) clearTimeout(shipBurstTimer);
    shipBurstTimer = setTimeout(() => {
      layer.remove();
    }, 2700);
  }

  function renderShippingProgress() {
    if (!els.shipWrap) return;

    const count = Number(cart.item_count || 0);
    const threshold = FREE_SHIP_THRESHOLD;
    const clamped = Math.max(0, Math.min(count, threshold));
    const pct = Math.round((clamped / threshold) * 100);
    const remaining = Math.max(0, threshold - count);

    if (els.shipCount) {
      els.shipCount.textContent = `${clamped}/${threshold}`;
    }

    if (els.shipBar) {
      els.shipBar.style.width = `${pct}%`;
    }

    els.shipWrap.style.setProperty('--imc-ship-progress', `${pct}%`);

    // La livraison N'EST PAS offerte (port réel configuré en Admin) : messages alignés
    // sur l'offre réelle (3e offert à 2 maillots) et frais toujours « Calculée au paiement ».
    if (els.shipMsg) {
      if (remaining > 1) {
        els.shipMsg.textContent = `Plus que ${remaining} maillots pour débloquer le 3e offert.`;
      } else if (remaining === 1) {
        els.shipMsg.textContent = 'Plus qu\'1 maillot pour débloquer le 3e offert.';
      } else {
        els.shipMsg.textContent = '3e maillot offert débloqué.';
      }
    }

    if (els.shippingValue) {
      els.shippingValue.classList.remove('imc-row__value--ok', 'imc-row__value--hint');
      els.shippingValue.textContent = 'Calculée au paiement';
      els.shippingValue.classList.add('imc-row__value--hint');
    }

    const step = remaining === 0 ? 2 : count > 0 ? 1 : 0;
    const isMidStep = step === 1 && clamped === 1;

    els.shipWrap.classList.toggle('is-half', isMidStep);
    els.shipWrap.classList.toggle('is-unlocked', step === 2);

    if (lastShippingStep >= 0 && step !== lastShippingStep && step > 0) {
      playShippingStepAnimation(step);
    }
    lastShippingStep = step;
  }

  /* ---------- Rendu global ---------- */
  // render(preloadedCart) : si un cart est fourni (ex: réponse de /cart/change.js),
  // on l'utilise directement → évite un fetch /cart.js redondant.
  let _cartRetry = 0;
  async function render(preloadedCart) {
    let fetched;
    try {
      fetched = (preloadedCart && Array.isArray(preloadedCart.items))
        ? preloadedCart
        : await getCart();
      fetched = await ensureNoUnexpectedShopifyDiscount(fetched);
    } catch (e) {
      /* Échec réseau /cart.js : on NE vide PAS la liste et on n'affiche pas
         un faux "panier vide" (perçu comme "articles cachés"). On retente ;
         l'affichage courant reste intact jusqu'à des données fiables. */
      if (_cartRetry < 3) {
        _cartRetry++;
        setTimeout(function () { render(preloadedCart).catch(function () {}); }, 800);
      }
      return;
    }
    _cartRetry = 0;
    cart = fetched;

    // Reset sécurité
    estimatedPercentDiscount = 0;
    promo3x2Discount = 0;
    freeUnitsMap = {};

    if (els.items) els.items.innerHTML = '';
    if (els.count) els.count.textContent = cart.item_count || 0;
    syncHeaderCounts(cart.item_count || 0);
    if (els.noteInput && document.activeElement !== els.noteInput) {
      const nextNote = cart.note || '';
      els.noteInput.value = nextNote;
      lastSavedNote = nextNote;
    }

    if (!cart.items.length) {
      if (els.empty) els.empty.hidden = false;
      // Toujours garder le panneau réduction fermé quand le panier est vide
      setDiscountPanelOpen(false, false);
      show(els.shippingRow, false);
      show(els.beforeRow, false);
      show(els.discountRow, false);
      show(els.discLine, false);
      if (els.total) els.total.textContent = money(0);
      updateCheckoutButtonLabel(0);
      renderShippingProgress();
      document.dispatchEvent(new CustomEvent('im:cart:updated', { detail: { count: 0 } }));
      return;
    }

    if (els.empty) els.empty.hidden = true;
    show(els.shippingRow, true);

    compute3for2(cart.items);

    // UNE ligne par variante+perso : les scissions de la remise (offert/−35%)
    // sont fusionnées ; le prix barré montre l'économie du groupe.
    groupCartItems(cart.items).forEach(it => {
      els.items.appendChild(itemNode(it));
    });

    applyDiscountPreview();
    const total = updateTotals();
    updateCheckoutButtonLabel(total);
    renderShippingProgress();

    document.dispatchEvent(new CustomEvent('im:cart:updated', { detail: { count: cart.item_count } }));
  }

  function setDiscountPanelOpen(open, focusInput = false) {
    if (!els.discPanel) return;

    if (open) {
      els.discPanel.removeAttribute('hidden');
      els.discPanel.classList.add('imc-disc--open');
      els.discTog?.setAttribute('aria-expanded', 'true');
      els.discTog?.querySelector('.imc-disc__icon')?.replaceChildren('−');

      if (focusInput) {
        requestAnimationFrame(() => {
          els.discInput?.focus({ preventScroll: true });
        });
      }
      return;
    }

    els.discPanel.classList.remove('imc-disc--open');
    els.discPanel.setAttribute('hidden', 'hidden');
    els.discTog?.setAttribute('aria-expanded', 'false');
    els.discTog?.querySelector('.imc-disc__icon')?.replaceChildren('+');
  }

  root.addEventListener('click', (e) => {
    const tog = e.target.closest('[data-imc-disc-tog]');
    if (!tog || !root.contains(tog)) return;
    const shouldOpen = els.discPanel?.hasAttribute('hidden');
    setDiscountPanelOpen(!!shouldOpen, !!shouldOpen);
  });

  /* ---------- Appliquer / Effacer code ---------- */
  els.discApply?.addEventListener('click', () => {
    discountCode = (els.discInput.value || '').trim().toUpperCase();
    // Aucune persistance locale: code actif seulement pour cette page.
    clearDiscountPersistence();

    // reset anti-boucle autoclear
    safeSessionRemove('imc_autoclear_discount');

    primeDiscountCookie();
    updateCheckoutLink();

    setTotalLoading(true);
    render().finally(() => setTotalLoading(false));
  });

  els.discClear?.addEventListener('click', () => {
    discountCode = '';
    clearDiscountPersistence();
    if (els.discInput) els.discInput.value = '';

    safeSessionRemove('imc_discount_primed');
    safeSessionRemove('imc_autoclear_discount');

    setTotalLoading(true);
    clearShopifyDiscountInBackground()
      .finally(() => {
        updateCheckoutLink();
        render().finally(() => setTotalLoading(false));
      });
  });

  els.discInput?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') { e.preventDefault(); els.discApply?.click(); }
  });

  els.noteInput?.addEventListener('input', () => {
    queueCartNoteSave();
  });
  els.noteInput?.addEventListener('blur', () => {
    saveCartNote(true);
  });

  /* ---------- Drawer open/close ---------- */
  let imcCloseTimer = null;
  let imcPrevOverflow = '';
  const legacyDrawerClasses = [
    'js-drawer-open',
    'js-drawer-open-left',
    'js-drawer-open-right',
    'drawer-open',
    'cart-open',
    'overflow-hidden'
  ];

  function clearLegacyDrawerLocks() {
    document.body.classList.remove(...legacyDrawerClasses, 'imc-open');
    document.documentElement.classList.remove(...legacyDrawerClasses);
    document.body.style.overflow = '';

    if (window.jQuery) {
      try {
        window.jQuery('.page-element').off('.drawer');
        window.jQuery('body, html').off('.drawer');
        window.jQuery(document).off('focusin.drawer_focus');
      } catch (_) {}
    }
  }

  function lockImCartScroll() {
    imcPrevOverflow = document.documentElement.style.overflow || '';
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('imc-open');
  }

  function unlockImCartScroll() {
    document.documentElement.style.overflow = imcPrevOverflow || '';
    document.body.classList.remove('imc-open');
    clearLegacyDrawerLocks();
  }

  function resetCartUiState() {
    root.classList.remove('imc--open', 'imc--closing');
    root.setAttribute('aria-hidden', 'true');
    if (imcCloseTimer) {
      clearTimeout(imcCloseTimer);
      imcCloseTimer = null;
    }
    unlockImCartScroll();
  }

  function open() {
    if (imcCloseTimer) { clearTimeout(imcCloseTimer); imcCloseTimer = null; }

    clearLegacyDrawerLocks();
    // Ouverture propre: ne jamais auto-déplier "Réduction"
    setDiscountPanelOpen(false, false);
    root.classList.remove('imc--closing');
    root.classList.add('imc--open');
    root.setAttribute('aria-hidden', 'false');

    lockImCartScroll();
  }

  function close() {
    if (!root.classList.contains('imc--open')) {
      unlockImCartScroll();
      return;
    }

    root.classList.add('imc--closing');
    root.classList.remove('imc--open');

    unlockImCartScroll();

    if (imcCloseTimer) clearTimeout(imcCloseTimer);
    imcCloseTimer = setTimeout(() => {
      root.classList.remove('imc--closing');
      root.setAttribute('aria-hidden', 'true');
    }, 320);
  }

  root.addEventListener('click', (e) => {
    if (e.target.matches('[data-imc-close], .imc__backdrop')) close();
  });

  function openAndRender() {
    if (!root.classList.contains('imc--open')) {
      open();
    }
    setTotalLoading(true);
    return render().finally(() => setTotalLoading(false));
  }

  /* ---------- Init ---------- */
  installHeaderCountAutoRefresh();
  clearDiscountPersistence();
  if (els.discInput) els.discInput.value = '';
  // Par défaut on laisse l'accordéon réduction fermé, même avec un code mémorisé
  setDiscountPanelOpen(false, false);
  updateCheckoutLink();
  setTotalLoading(true);
  render().finally(() => setTotalLoading(false));

  // API + triggers externes
  window.IMCart = { open: openAndRender, close, render };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-im-open-cart]');
    if (!t) return;
    e.preventDefault();
    openAndRender();
  });
  document.addEventListener('im:cart:updated', (e) => {
    if (typeof e?.detail?.count === 'number') {
      syncHeaderCounts(e.detail.count);
      return;
    }
    queueHeaderCountRefresh(40);
  });
  ['cart:updated', 'cart:item-added', 'added_to_cart', 'added.ajaxProduct', 'cart:add', 'product:added']
    .forEach((evt) => {
      document.addEventListener(evt, () => queueHeaderCountRefresh(70), true);
    });
  window.addEventListener('pageshow', () => {
    resetCartUiState();
    queueHeaderCountRefresh(0);
  });
  window.addEventListener('pagehide', resetCartUiState);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) queueHeaderCountRefresh(0);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();

/* Panier → cacher la bulle à l'ouverture, la remettre à la fermeture */
(() => {
  const cart = document.getElementById('im-cart') || document.querySelector('.imc');
  if (!cart) return;

  const KNOWN = [
    '.shopify-chat-bubble',
    '.gorgias-chat', '#gorgias-chat-container', 'iframe[src*="gorgias"]',
    '.tidio-chat', '#tidio-chat', 'iframe[src*="tidio"]',
    '.crisp-client', 'iframe[src*="crisp"]',
    '.intercom-lightweight-app', 'iframe[src*="intercom"]',
    '#tawkchat-minified', 'iframe[src*="tawk"]',
    '#hubspot-messages-iframe-container', 'iframe[id^="launcher"]'
  ];
  const FALLBACK_CANDIDATES = [
    'iframe[src*="chat"]',
    'iframe[id*="chat"]',
    '[id*="chat"]',
    '[class*="chat"]',
    '[id*="launcher"]',
    '[class*="launcher"]'
  ].join(',');

  const saved = new WeakMap();

  const collectWidgets = () => {
    const set = new Set();
    KNOWN.forEach(s => document.querySelectorAll(s).forEach(el => set.add(el)));
    document.querySelectorAll(FALLBACK_CANDIDATES).forEach(el => {
      if (!(el instanceof HTMLElement) || cart.contains(el)) return;
      const cs = getComputedStyle(el);
      if (cs.position !== 'fixed') return;
      const r = el.getBoundingClientRect();
      const nearBR = (innerWidth - r.right < 180) && (innerHeight - r.bottom < 180);
      const small  = r.width <= 360 && r.height <= 360;
      const zi     = parseInt(cs.zIndex || '0', 10);
      if ((nearBR && small && zi > 1000) || (el.tagName === 'IFRAME' && zi > 1000)) set.add(el);
    });
    return [...set];
  };

  const hide = () => {
    collectWidgets().forEach(el => {
      if (!saved.has(el)) saved.set(el, el.getAttribute('style') || '');
      el.style.cssText += ';opacity:0!important;visibility:hidden!important;pointer-events:none!important;';
    });
  };

  const show = () => {
    collectWidgets().forEach(el => {
      if (!saved.has(el)) return;
      const s = saved.get(el);
      s ? el.setAttribute('style', s) : el.removeAttribute('style');
      saved.delete(el);
    });
  };

  const isOpen = () => {
    const cs = getComputedStyle(cart);
    return cart.classList.contains('imc--open') ||
           cart.classList.contains('is-open') ||
           cart.getAttribute('aria-hidden') === 'false' ||
           cs.display === 'block';
  };

  const sync = () => (isOpen() ? hide() : show());
  let syncTimer = null;
  const scheduleSync = (delay = 80) => {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, delay);
  };

  new MutationObserver(() => scheduleSync(0))
    .observe(cart, { attributes:true, attributeFilter:['class','style','aria-hidden'] });
  new MutationObserver(() => scheduleSync(120)).observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-im-open-cart], .js-open-cart, [href="#cart-drawer"]')) {
      scheduleSync(0);
    }
    if (e.target.closest('[data-imc-close], .imc__backdrop')) {
      scheduleSync(0);
    }
  }, true);

  sync();
})();
